// DOM helper that fills a logo overlay's "From library" thumbnail grid.
// Extracted from the clip-builder monolith so the overlays controller only
// wires intent (fetch assets, handle selection) and this owns the repetitive
// button building. Pure DOM — unit-tested with jsdom.

import { libraryThumbInnerMarkup } from "./clip_builder_markup.js"

export function populateLibraryGrid(grid, assets, onSelect) {
  grid.innerHTML = ""
  grid.className = "grid grid-cols-8 gap-1 mt-1 max-h-24 overflow-y-auto"

  assets.forEach((asset) => {
    const thumb = document.createElement("button")
    thumb.type = "button"
    thumb.className =
      "group relative aspect-square rounded border-2 border-gray-200 hover:border-amber-400 overflow-hidden bg-gray-100 cursor-pointer"
    thumb.title = `Click to select: ${asset.name}`
    thumb.innerHTML = libraryThumbInnerMarkup(asset)
    thumb.addEventListener("click", () => onSelect(asset))
    grid.appendChild(thumb)
  })
}
